import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CaseStatus } from '../../models/case-card.model';

@Component({
  selector: 'app-status-badge',
  imports: [],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBadgeComponent {
  readonly status = input<CaseStatus>('open');
  readonly size = input<'sm' | 'md'>('md');

  readonly badgeClasses = computed(() => {
    const base =
      'inline-flex items-center rounded-full font-semibold ring-1 ring-inset';

    const sizeClasses =
      this.size() === 'sm'
        ? 'px-2 py-1 text-xs'
        : 'px-2.5 py-1 text-xs sm:px-3 sm:py-1.5 sm:text-sm';

    const toneClasses =
      this.status() === 'open'
        ? 'bg-emerald-50 text-emerald-700 ring-emerald-200'
        : 'bg-slate-100 text-slate-700 ring-slate-200';

    return `${base} ${sizeClasses} ${toneClasses}`;
  });

  readonly label = computed(() => (this.status() === 'open' ? 'Open' : 'Closed'));
}